export default "__VITE_ASSET__933f3ec7__"